/** Legacy single-key storage (cross-appointment leakage) — migrated per appointment when possible */
export const LEGACY_FORM_STORAGE_KEY = "patientMedicationInfo";

const DRAFT_PREFIX = "secopPatientFormDraft:";

export function getFormDraftStorageKey(appointmentId) {
  if (!appointmentId) return null;
  return `${DRAFT_PREFIX}${appointmentId}`;
}

/**
 * Load draft for this appointment only. Optionally migrates legacy global blob if it matches appointmentId.
 */
export function loadFormDraft(appointmentId) {
  const key = getFormDraftStorageKey(appointmentId);
  if (!key) return null;
  try {
    const raw = localStorage.getItem(key);
    if (raw) {
      return JSON.parse(raw);
    }
    const legacyRaw = localStorage.getItem(LEGACY_FORM_STORAGE_KEY);
    if (legacyRaw) {
      const parsed = JSON.parse(legacyRaw);
      if (parsed && String(parsed.appointmentId) === String(appointmentId)) {
        localStorage.setItem(key, legacyRaw);
        localStorage.removeItem(LEGACY_FORM_STORAGE_KEY);
        return parsed;
      }
    }
  } catch (e) {
    console.error("loadFormDraft", e);
  }
  return null;
}

export function saveFormDraft(appointmentId, payload) {
  const key = getFormDraftStorageKey(appointmentId);
  if (!key) return;
  localStorage.setItem(key, JSON.stringify(payload));
}

export function clearFormDraft(appointmentId) {
  const key = getFormDraftStorageKey(appointmentId);
  if (key) localStorage.removeItem(key);
  localStorage.removeItem(LEGACY_FORM_STORAGE_KEY);
}
